import React, { useEffect, useState } from "react";

import ProfileBox from "../../Components/ProfileBox/ProfileBox";
import { API } from "../../API";
import moment from "moment";

const CurrentInvoices = (props) => {
  const { user } = props;
  const [invoices, setInvoices] = useState([]);
  useEffect(() => {
    let is_personnel = user?.personnel_id ? true : false;
    API.getListInvoices(1, 4, user.customer_id ?? user?.personnel_id, { today: true }, is_personnel).then((result) => {
      setInvoices(result.data.data);
    });
  }, []);

  return (
    <ProfileBox
      header="Current Invoices"
    >
      {<div className='text-left' style={{ fontSize: "16px" }}>
        <div className="flex mb-2">
          <p className="col">
          </p>
          <a
            className="col"
            href="/InvoiceTable"
            target="_blank"
            style={{ color: "#4183c4" }}
          >
            View Invoices
          </a>
        </div>
        <div className="flex" style={{ fontSize: "14px" }}>
          {
            invoices.length > 0 && invoices.map(item => {
              return <a
                className="col"
                href={`/InvoiceDetails/${item._id}`}
                target="_blank"
                style={{ color: "#4183c4" }}
              >
                <i>{moment(item.invoice_period_start_date, 'YYYY-MM-DD').format('DD/MM/YYYY') + " " +
                  moment(item.invoice_period_end_date, 'YYYY-MM-DD').format('DD/MM/YYYY')}</i>
              </a>
            })
          }
        </div>
      </div>}
    </ProfileBox>
  );
}

export default CurrentInvoices;